module.exports = __webpack_public_path__ + "img/appAsset--customer-contact-ax.4b71424b.svg";